import * as React from "react";
import {Option} from "ts-option";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import SelectMerchant from "./SelectMerchant";
import Merchant from "../../../model/merchant/Merchant";

interface ReduxProps {
	merchants: Option<Merchant[]>;
}

type Props = FormGroupProps<string> & PlaceholderProps & ReduxProps;

class MerchantFormGroup extends React.PureComponent<Props> {
	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<SelectMerchant placeholder={this.props.placeholder}
								selectedId={this.props.field.getOptionalValue()}
								onChanged={this.onChange}
								items={this.props.merchants}
								clearable={true}
				/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed merchant.
	 * @param data
	 */
	onChange = (data: Option<Merchant>) => {
		this.props.onChange(this.props.field.updateValue(data.map((m) => m.id)));
	}
}

function mapStateToProps(state: RootState) {
	return {
		merchants: state.merchant.merchants
	};
}

export default connect(mapStateToProps)(MerchantFormGroup);